<template>
  <div
    v-if="props.alerts && props.alerts.length"
    class="app-alerts"
  >
    <div class="app-alerts__inner">
      <AppAlert
        v-for="alert in props.alerts"
        :key="alert.id"
        :id="alert.id"
        :status="alert.status"
        :title="alert.title"
        :messages="alert.messages"
        @close="$emit('removeAlert', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import AppAlert from '@/components/AppAlert.vue';

const props = defineProps({
  alerts: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.app-alerts {
  position: fixed;
  right: 20px;
  top: 20px;
  max-height: 100%;
  z-index: 1;
}

.app-alerts__inner {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 415px;
  max-height: 100%;

  @media screen and (max-width: 767px) {
    width: 340px;
  }
}
</style>
